import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SavedJobsByKeyQueryVariables = Types.Exact<{
    keys: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;

export type SavedJobsByKeyQuery = {
    __typename?: 'Query';
    savedJobsByKey?:
        | Array<
              | {
                    __typename?: 'SavedJob';
                    state: Types.SavedJobState;
                    job: { __typename?: 'Job'; key: string };
                }
              | null
              | undefined
          >
        | null
        | undefined;
};

export type SuccessPageQueryVariables = Types.Exact<{
    input: Types.FindReviewBeforeSubmitDraftsInput;
}>;

export type SuccessPageQuery = {
    __typename?: 'Query';
    findReviewBeforeSubmitDrafts?:
        | {
              __typename?: 'FindReviewBeforeSubmitDraftsPayload';
              drafts: Array<{
                  __typename?: 'AutoApplyDraft';
                  applicationDraftId: string;
                  state: Types.ReviewBeforeSubmitDraftState;
                  jobTitle: string;
                  jobLocation: string;
                  iaUid: string;
                  employerName?: string | null | undefined;
                  applyableJob: {
                      __typename?: 'ReviewBeforeSubmitApplyableJob';
                      jobId: string;
                      clientJobRef?: string | null | undefined;
                  };
              }>;
          }
        | null
        | undefined;
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
              mode?: Types.AutoApplyMode | null | undefined;
          }
        | null
        | undefined;
    currentUser?:
        | {
              __typename?: 'CurrentUserPayload';
              account?:
                  | {
                        __typename?: 'PassportAccount';
                        accountProfile?:
                            | {
                                  __typename?: 'AccountProfile';
                                  email?:
                                      | { __typename?: 'Email'; emailAddress: any }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export const SavedJobsByKeyDocument = gql`
    query SavedJobsByKey($keys: [ID!]!) {
        savedJobsByKey(keys: $keys) {
            state
            job {
                key
            }
        }
    }
`;

/**
 * __useSavedJobsByKeyQuery__
 *
 * To run a query within a React component, call `useSavedJobsByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedJobsByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedJobsByKeyQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useSavedJobsByKeyQuery(
    baseOptions: Apollo.QueryHookOptions<SavedJobsByKeyQuery, SavedJobsByKeyQueryVariables> &
        ({ variables: SavedJobsByKeyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SavedJobsByKeyQuery, SavedJobsByKeyQueryVariables>(
        SavedJobsByKeyDocument,
        options,
    );
}
export function useSavedJobsByKeyLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SavedJobsByKeyQuery, SavedJobsByKeyQueryVariables>,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SavedJobsByKeyQuery, SavedJobsByKeyQueryVariables>(
        SavedJobsByKeyDocument,
        options,
    );
}
export function useSavedJobsByKeySuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<SavedJobsByKeyQuery, SavedJobsByKeyQueryVariables>,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<SavedJobsByKeyQuery, SavedJobsByKeyQueryVariables>(
        SavedJobsByKeyDocument,
        options,
    );
}
export type SavedJobsByKeyQueryHookResult = ReturnType<typeof useSavedJobsByKeyQuery>;
export type SavedJobsByKeyLazyQueryHookResult = ReturnType<typeof useSavedJobsByKeyLazyQuery>;
export type SavedJobsByKeySuspenseQueryHookResult = ReturnType<
    typeof useSavedJobsByKeySuspenseQuery
>;
export type SavedJobsByKeyQueryResult = Apollo.QueryResult<
    SavedJobsByKeyQuery,
    SavedJobsByKeyQueryVariables
>;
export const SuccessPageDocument = gql`
    query SuccessPage($input: FindReviewBeforeSubmitDraftsInput!) {
        findReviewBeforeSubmitDrafts(input: $input) {
            drafts {
                applicationDraftId
                state
                jobTitle
                jobLocation
                applyableJob {
                    jobId
                    clientJobRef
                }
                iaUid
                employerName
            }
        }
        autoApplyInfo {
            autoApplyStatus
            mode
        }
        currentUser {
            account {
                ... on PassportAccount {
                    accountProfile {
                        email {
                            emailAddress
                        }
                    }
                }
            }
        }
    }
`;

/**
 * __useSuccessPageQuery__
 *
 * To run a query within a React component, call `useSuccessPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuccessPageQuery(
    baseOptions: Apollo.QueryHookOptions<SuccessPageQuery, SuccessPageQueryVariables> &
        ({ variables: SuccessPageQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SuccessPageQuery, SuccessPageQueryVariables>(
        SuccessPageDocument,
        options,
    );
}
export function useSuccessPageLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SuccessPageQuery, SuccessPageQueryVariables>,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SuccessPageQuery, SuccessPageQueryVariables>(
        SuccessPageDocument,
        options,
    );
}
export function useSuccessPageSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<SuccessPageQuery, SuccessPageQueryVariables>,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<SuccessPageQuery, SuccessPageQueryVariables>(
        SuccessPageDocument,
        options,
    );
}
export type SuccessPageQueryHookResult = ReturnType<typeof useSuccessPageQuery>;
export type SuccessPageLazyQueryHookResult = ReturnType<typeof useSuccessPageLazyQuery>;
export type SuccessPageSuspenseQueryHookResult = ReturnType<typeof useSuccessPageSuspenseQuery>;
export type SuccessPageQueryResult = Apollo.QueryResult<
    SuccessPageQuery,
    SuccessPageQueryVariables
>;
